import { ExprValue } from '../ExprValue';
import { validateArguments } from '../../SignatureValidation';
import { Types } from '../../Switch';
export var FloatFn;
(function (FloatFn) {
    FloatFn.Name = `FLOAT`;
    FloatFn.Stage = "SCALAR";
    FloatFn.Signature = `FLOAT(<expression>)`;
    function make(callName, args, type, role) {
        return {
            name: FloatFn.Name,
            stage: FloatFn.Stage,
            data: { type, role },
            value: (...argVals) => {
                if (argVals.length !== 1) {
                    throw new Error(`FLOAT function needs 1 argument but received ${argVals.length}`);
                }
                const [value] = argVals;
                if (value == null) {
                    return null;
                }
                let numberValue = value;
                if (typeof value === 'boolean') {
                    return value ? 1 : 0;
                }
                if (typeof value === 'string') {
                    const input = value.trim();
                    if (input === '') {
                        return null;
                    }
                    const parsed = +numberValue;
                    if (!Number.isFinite(parsed)) {
                        return null;
                    }
                    numberValue = ExprValue.parseNumber(input);
                    if (ExprValue.isSafeNumber(parsed)) {
                        numberValue = +numberValue;
                    }
                }
                if (ExprValue.isNumberValue(numberValue)) {
                    numberValue = +numberValue;
                    if (!Number.isFinite(numberValue)) {
                        return null;
                    }
                    if (Types.nodeResolvesToDateLikeType(args[0])) {
                        numberValue = numberValue / 1000;
                    }
                    return numberValue;
                }
                throw new Error(`FLOAT function expects number, string, date or boolean input and received (${typeof numberValue})`);
            },
        };
    }
    FloatFn.make = make;
    function validate(callNode, callName, args) {
        return validateArguments({
            meta: { name: FloatFn.Name, signature: FloatFn.Signature, location: callNode.location },
            arguments: [{}],
        }, args);
    }
    FloatFn.validate = validate;
})(FloatFn || (FloatFn = {}));
